export enum Role {
	ADMIN = 'ADMIN',
	DOCTOR = 'DOCTOR',
	GUEST = 'GUEST'
}
